// @ts-check

import React, { useEffect, useState } from 'react';
import SelectTabContext from './SelectTabContext';

const SelectTabContextProvider = ({ children }) => {
  const [windowsData, setWindowData] = useState([
    { label: 'Account Guarantor', code: 'W61', windowType: 'Core Windows' },
    { label: 'Account Notes', code: 'W32', windowType: 'Core Windows' },
    { label: 'Account Tie', code: 'W51', windowType: 'Core Windows' },
    { label: 'Add a Note', code: 'W8', windowType: 'Core Windows' },
    { label: 'CBS Insurance', code: 'W6', windowType: 'Core Windows' },
    { label: 'Address History', code: 'W11', windowType: 'Core Windows' },
    { label: 'Agent / Advocate Information', code: 'AGENT_INFO', windowType: 'Core Windows' },
    { label: 'Client Information', code: 'W13', windowType: 'Core Windows' },
    { label: 'Communication History', code: 'W52,W95', windowType: 'Core Windows' },
    { label: 'Patient / Customer Demographics', code: 'W2,W4', windowType: 'Core Windows' },
    { label: 'Document Management', code: 'W47', windowType: 'Core Windows' },
    { label: 'Eligibility Vendor Response View', code: 'ESP', windowType: 'Core Windows' },
    { label: 'Messages', code: 'W44', windowType: 'Core Windows' },
    { label: 'Multiple Account Information', code: 'CW_W3', windowType: 'Core Windows' },
    { label: 'Status Timeline', code: 'ST', windowType: 'Core Windows' },
    { label: 'Billing Indicator', code: 'BI', windowType: 'Core Windows' },
    { label: 'My Coverage Care', code: 'MCC', windowType: 'Core Windows' },
  ]);
  const [clientMaintainanceData] = useState([
    { label: 'Corresponding Clients (W3)', code: 'W3' },
    { label: 'Collection (W4)', code: 'W4' },
    { label: 'New Business (W5)', code: 'W5' },
    { label: 'Client Notes (W7)', code: 'W7' },
    { label: 'Billing (W16)', code: 'W16' },
    { label: 'Debtor Cash (W18)', code: 'W18' },
    { label: 'Statement (W19)', code: 'W19' },
  ]);
  const [defaultWindows] = useState([
    { label: 'Important Notes', code: '10', hideDeleteIcon: true },
    { label: 'Account Status', code: 'Account Status', hideDeleteIcon: true },
  ]);

  const [selectedTabs, setSelectedTabs] = useState(() => {
    const storedTabs = localStorage.getItem('selectedTabs');
    return storedTabs ? JSON.parse(storedTabs) : [];
  });

  const [auditLogs, setAuditLogs] = useState([]);
  const [selectedCMTabs, setSelectedCMTabs] = useState([]);
  const [hideSummary, setSummary] = useState(true);
  const [age, setAge] = useState(false);
  const [selectTab, setSelectedTab] = useState('');
  const [communication, setCommunication] = useState('');
  const [label, setLabel] = React.useState(['Important Notes']);
  const [HeaderFavourites, setHeaderFavourites] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [fullScreenForCont, setFullScreenForCont] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchAny, setSearchAny] = useState({ key: 'accountNumber', value: 'Account No' });
  const [searchClientPrefix, setSearchClientPrefix] = useState(false);
  const [debtorAccNum, setDebtorAccNum] = useState('');
  const [search, setSearch] = useState(false);
  const [newTabData, setNewTabData] = useState([]);
  const [searchAnySubmit, setSearchAnySubmit] = useState(false);
  const [advanceSearchSubmit, setAdvanceSearchSubmit] = useState(false);
  const [onChipClick, setOnChipClick] = useState(false);
  const [currentLabel, setCurrentLabel] = useState('');
  const [seedAccount, setSeedAccount] = useState('');
  const [previousFavTabs, setPreviousFavTabs] = useState([]);
  const [sideNavAccNotes, setSideNavAccNotes] = useState(false);
  const [isLookupUDWData, setIsLookupUDWdata] = useState(false);
  const [expiryMsg, setExpiryMsg] = useState('');
  const [position, setPosition] = useState(0);
  const [settingsW3, setSettingsW3] = useState(false);
  const [editRecordFormatId, setEditRecordFormatId] = useState(null);
  const [editRuleGroupId, setEditRuleGroupId] = useState(null);
  const [selectedNbTabs, setSelectedNbTabs] = useState([]);
  const [nbTab, setNBTab] = useState(false);
  const [ClientNewTabData, setClientNewTabData] = useState([]);
  const [ClientSearchData, setClientSearchData] = useState([]);
  const [breSelectedTab, setBreSelectedTab] = useState(2);
  const [ssnValidation, setssnValidation] = useState(true);
  const [dateValidation, setDateValidation] = useState(true);
  const [justClientAdded, setJustClientAdded] = useState(true);
  const [favCustomWindow, setFavCustomWindow] = useState('');
  const [selectedArray, setSelectedArray] = useState([]);
  const [chipCount, setChipCount] = useState();
  const [globalFieldRow, setGlobalFieldRow] = useState(false);
  const [saveTab, setSaveTab] = useState(false);
  const [sample, setSample] = useState(false);
  const [newTabValue, setNewTabValue] = useState();
  const [toggleWorkqueue, setToggleWorkqueue] = useState(false);
  const [updateWqSplitData, setUpdateWqSplitData] = useState(false);
  const [favouriteBlock, setFavouriteBlock] = useState(true);
  const [currentSelectedTab, setCurrentSelectedTab] = useState({});
  const [focusedWindows, setFocusedWindows] = useState([]);

  useEffect(() => {
    localStorage.setItem('selectedTabs', JSON.stringify(selectedTabs));
  }, [selectedTabs]);

  return (
    <SelectTabContext.Provider
      value={{
        currentPage,
        setCurrentPage,
        HeaderFavourites,
        setHeaderFavourites,
        searchAnySubmit,
        setSearchAnySubmit,
        selectedNbTabs,
        setSelectedNbTabs,
        onChipClick,
        setOnChipClick,
        currentLabel,
        setCurrentLabel,
        advanceSearchSubmit,
        setAdvanceSearchSubmit,
        search,
        setSearch,
        selectedTabs,
        setSelectedTabs,
        setWindowData,
        windowsData,
        clientMaintainanceData,
        fullScreenForCont,
        setFullScreenForCont,
        debtorAccNum,
        setDebtorAccNum,
        selectTab,
        setSelectedTab,
        communication,
        setCommunication,
        searchText,
        setSearchText,
        searchAny,
        setSearchAny,
        label,
        setLabel,
        seedAccount,
        setSeedAccount,
        sideNavAccNotes,
        setSideNavAccNotes,
        selectedCMTabs,
        setSelectedCMTabs,
        previousFavTabs,
        setPreviousFavTabs,
        isLookupUDWData,
        setIsLookupUDWdata,
        newTabData,
        setNewTabData,
        expiryMsg,
        setExpiryMsg,
        position,
        setPosition,
        settingsW3,
        setSettingsW3,
        editRecordFormatId,
        setEditRecordFormatId,
        editRuleGroupId,
        setEditRuleGroupId,
        nbTab,
        setNBTab,
        ClientNewTabData,
        setClientNewTabData,
        setClientSearchData,
        ClientSearchData,
        breSelectedTab,
        setBreSelectedTab,
        ssnValidation,
        setssnValidation,
        dateValidation,
        setDateValidation,
        justClientAdded,
        setJustClientAdded,
        setSearchClientPrefix,
        searchClientPrefix,
        favCustomWindow,
        setFavCustomWindow,
        selectedArray,
        setSelectedArray,
        chipCount,
        setChipCount,
        globalFieldRow,
        setGlobalFieldRow,
        saveTab,
        setSaveTab,
        sample,
        setSample,
        newTabValue,
        setNewTabValue,
        toggleWorkqueue,
        setToggleWorkqueue,
        updateWqSplitData,
        setUpdateWqSplitData,
        setFavouriteBlock,
        favouriteBlock,
        hideSummary,
        setSummary,
        age,
        setAge,
        currentSelectedTab,
        setCurrentSelectedTab,
        defaultWindows,
        focusedWindows,
        setFocusedWindows,
        auditLogs,
        setAuditLogs,
      }}
    >
      {children}
    </SelectTabContext.Provider>
  );
};

export default SelectTabContextProvider;
